/*
 * ACTION ITEMS FROM A CALL on the client: what Gabriel said he'd send or do on a
 * lead call, not yet ticked (the `call_actions` kind, src/actions/model.js; the
 * items are src/calls/promises.js openPromises). The server decides what is open;
 * this only words it for the board's tag, Today's row and the record's line.
 */

export const CALL_ACTIONS = "call_actions";

/** The card's call_actions action, or null. */
export function callActionsOf(chip) {
  const list = (chip && chip.actions) || [];
  return list.find((a) => a.kind === CALL_ACTIONS) || null;
}

/** "1 action item", "3 action items". */
export function itemsLabel(action) {
  const n = ((action && action.items) || []).length || 1;
  return n === 1 ? "1 action item" : `${n} action items`;
}

/** The hover: one line per item. */
export function itemsTitle(action) {
  const items = (action && action.items) || [];
  return items.map((i) => `• ${i.text}`).join("\n") || (action && action.detail) || "";
}

/** The items grouped by the call they came from, newest call first: [{ activity_id, call_at, items }]. */
export function byCall(items) {
  const groups = [];
  for (const item of items || []) {
    const last = groups[groups.length - 1];
    if (last && last.activity_id === item.activity_id) last.items.push(item);
    else groups.push({ activity_id: item.activity_id, call_at: item.call_at, items: [item] });
  }
  return groups;
}

/** POST body for the tick route (src/routes/crm.js /activities/:id/promises). */
export function tickPath(item) {
  return `/activities/${encodeURIComponent(item.activity_id)}/promises`;
}

/*
 * The tick and its undo (asked 2026-10-27: "I accidentally ticked that I did
 * this action item. Need an undo."). One request either way; done:false puts
 * the item back on the board tag, Today and Next.
 */
export function tickRequest(item, done = true) {
  return { method: "POST", body: JSON.stringify({ key: item.key, done }) };
}
